// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myprop {
  display: block;
  padding: 16px 17px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
  text-decoration: none;
  transition: border-color 0.2s, transform 0.15s;
}

.myprop:hover {
  border-color: var(--brand-300);
  transform: translateY(-2px);
}

.myprop-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
}

.myprop-top h3 {
  font-size: 0.99rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--text);
}

.myprop-price {
  font-family: var(--font-display);
  font-weight: 700;
  color: var(--brand);
}
`, "",{"version":3,"sources":["webpack://./src/app/provider/MyProposals.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".myprop {\n  display: block;\n  padding: 16px 17px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n  text-decoration: none;\n  transition: border-color 0.2s, transform 0.15s;\n}\n\n.myprop:hover {\n  border-color: var(--brand-300);\n  transform: translateY(-2px);\n}\n\n.myprop-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 9px;\n}\n\n.myprop-top h3 {\n  font-size: 0.99rem;\n  font-weight: 700;\n  line-height: 1.35;\n  color: var(--text);\n}\n\n.myprop-price {\n  font-family: var(--font-display);\n  font-weight: 700;\n  color: var(--brand);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
